import { useMemo } from 'react';

import './index.css';
import { Subscription } from '../../../../../types/subscription';
import AssetIcon from '../../../../../components/AssetIcon';
import {
  formatBalance,
  formatNumber,
} from '../../../../../helpers/NumberFormatter';

interface Props {
  subscription: Subscription;
}

const BasicInfo: React.FC<Props> = (props: Props) => {
  const { subscription } = props;
  const {
    baseAsset,
    quoteAsset,
    isActive,
    latestTransaction,
    totalBalanceInStable,
    stableBalance,
    assetBalance,
    exchange,
  } = subscription;

  const hasBaseAsset = useMemo(
    () => latestTransaction?.orderType === 'BUY',
    [latestTransaction?.orderType],
  );

  const hasQuoteAsset = useMemo(
    () => latestTransaction?.orderType === 'SELL',
    [latestTransaction?.orderType],
  );

  return (
    <div className="basic-info-container">
      <div className="basic-info-asset-icon-container">
        <AssetIcon baseAsset={baseAsset} width={'100%'} height={'100%'} />
        <div className="basic-info-active-container">
          {isActive ? (
            <div className="basic-info-active" />
          ) : (
            <div className="basic-info-inactive" />
          )}
        </div>
      </div>

      {/* <div className="bi-column">
        <h2 className="bi-text">
          <span className="bi-label">Bot Id:</span> {bot.botId}
        </h2>
        <h2 className="bi-text">
          <span className="bi-label">Cluster Id:</span> {bot.clusterId}
        </h2>
      </div> */}
      <div className="bi-column">
        <h3 className="bi-text">
          <span className="bi-label">Base Asset:</span> {baseAsset}
        </h3>
        <h3 className="bi-text">
          <span className="bi-label">Quote Asset:</span> {quoteAsset}
        </h3>
        <h3 className="bi-text">
          <span className="bi-label">Exchange:</span> {exchange}
        </h3>
      </div>
      <div className="bi-column bi-more-space">
        <h3 className="bi-text">
          <span className="bi-label">Total Balance:</span>{' '}
          {formatBalance(totalBalanceInStable)}
        </h3>
        <h3 className={`bi-text ${!hasQuoteAsset && 'bi-label'}`}>
          <span className="bi-label">Stable Balance:</span>{' '}
          {formatBalance(stableBalance)}
        </h3>
        <h3 className={`bi-text ${!hasBaseAsset && 'bi-label'}`}>
          <span className="bi-label">Asset Balance:</span>{' '}
          {formatNumber(assetBalance, 2)} {baseAsset}
        </h3>
      </div>
    </div>
  );
};

export default BasicInfo;
